export const SDK_READY           = 'SDK_READY';
export const SDK_REFRESHING      = 'SDK_REFRESHING';
export const SDK_LOADING         = 'SDK_LOADING';
export const SDK_ERROR           = 'SDK_ERROR';
export const SDK_CLEAR_ERROR     = 'SDK_CLEAR_ERROR';
export const SDK_CLEAR_ERRORS    = 'SDK_CLEAR_ERRORS';

export const SDK_ME              = 'SDK_ME';
export const SDK_TO_ROUTE        = 'SDK_TO_ROUTE';
export const SDK_APP_VALUE       = 'SDK_APP_VALUE';
export const SDK_ENTITY_VALUE    = 'SDK_ENTITY_VALUE';
export const SDK_OAUTH_PROVIDER  = 'SDK_OAUTH_PROVIDER';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js